var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1070.48 626.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#91b3fa;}.cls-5{fill:#7d97f4;}.cls-6{fill:#bdd0fb;}.cls-7{fill:#dce5fe;}.cls-8{fill:#f0f0f0;}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{mix-blend-mode:soft-light;}.cls-12{fill:#fff;}.cls-13{fill:#18174a;}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:#2b69b3;}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:url(#linear-gradient-9);}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{clip-path:url(#clip-path);}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#linear-gradient-16);}.cls-29{fill:url(#linear-gradient-17);}.cls-30{fill:url(#linear-gradient-18);}.cls-31{fill:url(#linear-gradient-19);}.cls-32{fill:url(#linear-gradient-20);}.cls-33{fill:url(#linear-gradient-21);}.cls-34{fill:url(#linear-gradient-22);}.cls-35{fill:url(#linear-gradient-23);}.cls-36{fill:url(#linear-gradient-24);}.cls-37{fill:url(#linear-gradient-25);}.cls-38{fill:url(#linear-gradient-26);}.cls-39{fill:url(#linear-gradient-27);}.cls-40{fill:url(#linear-gradient-28);}.cls-41{fill:url(#linear-gradient-29);}.cls-42{fill:url(#linear-gradient-30);}.cls-43{fill:url(#linear-gradient-31);}.cls-44{fill:url(#linear-gradient-32);}.cls-45{fill:url(#linear-gradient-33);}.cls-46{fill:url(#linear-gradient-34);}.cls-47{fill:url(#linear-gradient-35);}.cls-48{fill:url(#linear-gradient-36);}.cls-49{fill:url(#linear-gradient-37);}.cls-50{fill:url(#linear-gradient-38);}.cls-51{fill:url(#linear-gradient-39);}.cls-52{fill:url(#linear-gradient-40);}.cls-53{fill:url(#linear-gradient-41);}.cls-54{fill:url(#linear-gradient-42);}.cls-55{fill:url(#linear-gradient-43);}.cls-56{fill:url(#linear-gradient-44);}.cls-57{fill:url(#linear-gradient-45);}.cls-58{fill:url(#linear-gradient-46);}.cls-59{fill:url(#linear-gradient-47);}.cls-60{fill:url(#linear-gradient-48);}.cls-61{fill:url(#linear-gradient-49);}.cls-62{fill:url(#linear-gradient-50);}.cls-63{fill:url(#linear-gradient-51);}.cls-64{fill:url(#linear-gradient-52);}.cls-65{fill:url(#linear-gradient-53);}.cls-66{fill:url(#linear-gradient-54);}.cls-67{fill:url(#linear-gradient-55);}.cls-68{fill:url(#linear-gradient-56);}.cls-69{fill:url(#linear-gradient-57);}.cls-70{fill:url(#linear-gradient-58);}.cls-71{fill:url(#linear-gradient-59);}.cls-72{fill:url(#linear-gradient-60);}.cls-73{fill:url(#linear-gradient-61);}.cls-74{fill:url(#linear-gradient-62);}.cls-75{fill:url(#linear-gradient-63);}.cls-76{fill:url(#linear-gradient-64);}.cls-77{fill:url(#linear-gradient-65);}.cls-78{fill:url(#linear-gradient-66);}.cls-79{fill:url(#linear-gradient-67);}.cls-80{fill:url(#linear-gradient-68);}.cls-81{fill:url(#linear-gradient-69);}.cls-82{fill:url(#linear-gradient-70);}.cls-83{fill:url(#linear-gradient-71);}.cls-84{fill:url(#linear-gradient-72);}.cls-85{fill:url(#linear-gradient-73);}.cls-86{fill:url(#linear-gradient-74);}.cls-87{fill:url(#linear-gradient-75);}.cls-88{fill:url(#linear-gradient-76);}.cls-89{fill:url(#linear-gradient-77);}.cls-90{fill:url(#linear-gradient-78);}.cls-91{fill:url(#linear-gradient-79);}.cls-92{fill:url(#linear-gradient-80);}.cls-93{fill:url(#linear-gradient-81);}.cls-94{fill:url(#linear-gradient-82);}.cls-95{fill:url(#linear-gradient-83);}.cls-96{fill:url(#linear-gradient-84);}.cls-97{fill:url(#linear-gradient-85);}.cls-98{fill:url(#linear-gradient-86);}.cls-99{fill:url(#linear-gradient-87);}.cls-100{fill:url(#linear-gradient-88);}.cls-101{fill:url(#linear-gradient-89);}.cls-102{fill:url(#linear-gradient-90);}.cls-103{fill:url(#linear-gradient-91);}.cls-104{fill:url(#linear-gradient-92);}.cls-105{fill:url(#linear-gradient-93);}.cls-106{fill:url(#linear-gradient-94);}.cls-107{fill:url(#linear-gradient-95);}.cls-108{fill:url(#linear-gradient-96);}.cls-109{fill:url(#linear-gradient-97);}.cls-110{fill:url(#linear-gradient-98);}.cls-111{fill:url(#linear-gradient-99);}.cls-112{fill:url(#linear-gradient-100);}.cls-113{fill:url(#linear-gradient-101);}.cls-114{fill:url(#linear-gradient-102);}.cls-115{fill:url(#linear-gradient-103);}.cls-116{fill:url(#linear-gradient-104);}.cls-117{fill:url(#linear-gradient-105);}.cls-118{fill:url(#linear-gradient-106);}.cls-119{fill:url(#linear-gradient-107);}.cls-120{fill:url(#linear-gradient-108);}.cls-121{fill:url(#linear-gradient-109);}.cls-122{fill:url(#linear-gradient-110);}.cls-123{fill:url(#linear-gradient-111);}.cls-124{fill:url(#linear-gradient-112);}.cls-125{fill:url(#linear-gradient-113);}.cls-126{fill:url(#linear-gradient-114);}.cls-127{fill:url(#linear-gradient-115);}.cls-128{fill:url(#linear-gradient-116);}.cls-129{fill:url(#linear-gradient-117);}.cls-130{fill:url(#linear-gradient-118);}.cls-131{fill:url(#linear-gradient-119);}.cls-132{fill:url(#linear-gradient-120);}.cls-133{fill:url(#linear-gradient-121);}.cls-134{fill:url(#linear-gradient-122);}.cls-135{fill:url(#linear-gradient-123);}.cls-136{fill:url(#linear-gradient-124);}.cls-137{fill:url(#linear-gradient-125);}.cls-138{fill:url(#linear-gradient-126);}.cls-139{fill:url(#linear-gradient-127);}.cls-140{fill:url(#linear-gradient-128);}.cls-141{fill:url(#linear-gradient-129);}.cls-142{fill:url(#linear-gradient-130);}.cls-143{fill:url(#linear-gradient-131);}.cls-144{fill:url(#linear-gradient-132);}.cls-145{fill:url(#linear-gradient-133);}.cls-146{fill:url(#linear-gradient-134);}.cls-147{fill:url(#linear-gradient-135);}.cls-148{fill:url(#linear-gradient-136);}.cls-149{fill:url(#linear-gradient-137);}.cls-150{fill:url(#linear-gradient-138);}.cls-151{fill:url(#linear-gradient-139);}.cls-152{fill:url(#linear-gradient-140);}.cls-153{fill:url(#linear-gradient-141);}.cls-154{fill:url(#linear-gradient-142);}.cls-155{fill:url(#linear-gradient-143);}.cls-156{fill:url(#linear-gradient-144);}.cls-157{fill:url(#linear-gradient-145);}.cls-158{fill:url(#linear-gradient-146);}.cls-159{fill:url(#linear-gradient-147);}.cls-160{fill:url(#linear-gradient-148);}.cls-161{fill:url(#linear-gradient-149);}.cls-162{fill:url(#linear-gradient-150);}.cls-163{fill:url(#linear-gradient-151);}.cls-164{fill:url(#linear-gradient-152);}.cls-165{fill:url(#linear-gradient-153);}.cls-166{fill:url(#linear-gradient-154);}.cls-167{fill:url(#linear-gradient-155);}.cls-168{fill:url(#linear-gradient-156);}.cls-169{fill:url(#linear-gradient-157);}.cls-170{fill:url(#linear-gradient-158);}.cls-171{fill:url(#linear-gradient-159);}.cls-172{fill:url(#linear-gradient-160);}.cls-173{fill:url(#linear-gradient-161);}.cls-174{fill:url(#linear-gradient-162);}.cls-175{fill:url(#linear-gradient-163);}.cls-176{fill:url(#linear-gradient-164);}.cls-177{fill:url(#linear-gradient-165);}.cls-178{fill:url(#linear-gradient-166);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -963.02,
    y1: 2877.52,
    x2: 107.46,
    y2: 2877.52,
    gradientTransform: "translate(107.46 3179.57) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 524.04,
    y1: 144.75,
    x2: 553.38,
    y2: 841.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 523.79,
    y1: -7.89,
    x2: 552.16,
    y2: 665.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 716.46,
    y1: 623.21,
    x2: 700.87,
    y2: 552.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 743.85,
    y1: 454,
    x2: 707.26,
    y2: 543.09,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 717.2,
    y1: 464.94,
    x2: 732.79,
    y2: 503.12,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2787.23,
    y1: 656.97,
    x2: 2811.73,
    y2: 654.42,
    gradientTransform: "translate(-3933.96)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2787.7,
    y1: 661.4,
    x2: 2812.19,
    y2: 658.86,
    gradientTransform: "translate(-3933.96)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 802.32,
    y1: 538.92,
    x2: 727.24,
    y2: 532.24,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 600.74,
    y1: 544.35,
    x2: 805.2,
    y2: 544.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 612.48,
    y1: 589.16,
    x2: 652.85,
    y2: 589.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 617.14,
    y1: 589.16,
    x2: 657.51,
    y2: 589.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 757.58,
    y1: 589.16,
    x2: 797.95,
    y2: 589.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 762.24,
    y1: 589.16,
    x2: 802.61,
    y2: 589.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "271.1 278.48 535.6 438.15 785.02 287.92 785.02 55.33 291.86 55.33 271.1 278.48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 939.15,
    y1: 287.13,
    x2: 940.45,
    y2: 287.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 939.66,
    y1: 297.26,
    x2: 940.81,
    y2: 297.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 939.04,
    y1: 307.39,
    x2: 940.54,
    y2: 307.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 937.59,
    y1: 317.45,
    x2: 939.44,
    y2: 317.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 935.33,
    y1: 327.37,
    x2: 937.53,
    y2: 327.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 932.31,
    y1: 337.1,
    x2: 934.83,
    y2: 337.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 928.55,
    y1: 346.58,
    x2: 931.4,
    y2: 346.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 924.09,
    y1: 355.77,
    x2: 927.25,
    y2: 355.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 918.96,
    y1: 364.6,
    x2: 922.43,
    y2: 364.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 913.2,
    y1: 373.05,
    x2: 916.96,
    y2: 373.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 906.83,
    y1: 381.05,
    x2: 910.87,
    y2: 381.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 899.87,
    y1: 388.56,
    x2: 904.19,
    y2: 388.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 892.36,
    y1: 395.52,
    x2: 896.95,
    y2: 395.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 884.33,
    y1: 401.88,
    x2: 889.18,
    y2: 401.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 875.84,
    y1: 407.57,
    x2: 880.92,
    y2: 407.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 866.91,
    y1: 412.55,
    x2: 872.18,
    y2: 412.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 857.6,
    y1: 416.75,
    x2: 863.04,
    y2: 416.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 847.98,
    y1: 420.15,
    x2: 853.56,
    y2: 420.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 838.13,
    y1: 422.79,
    x2: 843.83,
    y2: 422.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 828.12,
    y1: 424.68,
    x2: 833.92,
    y2: 424.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 818,
    y1: 425.83,
    x2: 823.88,
    y2: 425.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 807.84,
    y1: 426.28,
    x2: 813.79,
    y2: 426.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 797.68,
    y1: 426.05,
    x2: 803.68,
    y2: 426.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 787.55,
    y1: 425.2,
    x2: 793.59,
    y2: 425.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 777.5,
    y1: 423.75,
    x2: 783.57,
    y2: 423.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 767.55,
    y1: 421.74,
    x2: 773.65,
    y2: 421.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 757.72,
    y1: 419.2,
    x2: 763.84,
    y2: 419.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 748.04,
    y1: 416.15,
    x2: 754.17,
    y2: 416.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 738.52,
    y1: 412.64,
    x2: 744.66,
    y2: 412.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 729.19,
    y1: 408.66,
    x2: 735.33,
    y2: 408.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 720.05,
    y1: 404.25,
    x2: 726.19,
    y2: 404.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 711.16,
    y1: 399.43,
    x2: 717.26,
    y2: 399.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 702.47,
    y1: 394.24,
    x2: 708.53,
    y2: 394.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 693.98,
    y1: 388.72,
    x2: 699.99,
    y2: 388.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 685.69,
    y1: 382.91,
    x2: 691.66,
    y2: 382.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 677.59,
    y1: 376.84,
    x2: 683.52,
    y2: 376.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 669.67,
    y1: 370.52,
    x2: 675.57,
    y2: 370.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 661.92,
    y1: 364,
    x2: 667.79,
    y2: 364,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 654.33,
    y1: 357.28,
    x2: 660.17,
    y2: 357.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 646.89,
    y1: 350.41,
    x2: 652.7,
    y2: 350.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 639.57,
    y1: 343.4,
    x2: 645.37,
    y2: 343.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 632.36,
    y1: 336.27,
    x2: 638.14,
    y2: 336.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 625.25,
    y1: 329.04,
    x2: 631.02,
    y2: 329.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 618.21,
    y1: 321.73,
    x2: 623.98,
    y2: 321.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 611.23,
    y1: 314.36,
    x2: 617.01,
    y2: 314.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 604.3,
    y1: 306.95,
    x2: 610.08,
    y2: 306.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 597.39,
    y1: 299.51,
    x2: 603.18,
    y2: 299.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 590.48,
    y1: 292.07,
    x2: 596.29,
    y2: 292.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 583.55,
    y1: 284.65,
    x2: 589.39,
    y2: 284.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 576.58,
    y1: 277.27,
    x2: 582.46,
    y2: 277.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 569.56,
    y1: 269.93,
    x2: 575.48,
    y2: 269.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 562.46,
    y1: 262.66,
    x2: 568.42,
    y2: 262.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 555.27,
    y1: 255.49,
    x2: 561.28,
    y2: 255.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 547.97,
    y1: 248.42,
    x2: 554.04,
    y2: 248.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 540.56,
    y1: 241.48,
    x2: 546.66,
    y2: 241.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 533,
    y1: 234.69,
    x2: 539.13,
    y2: 234.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 525.29,
    y1: 228.08,
    x2: 531.46,
    y2: 228.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 517.42,
    y1: 221.68,
    x2: 523.62,
    y2: 221.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 509.36,
    y1: 215.5,
    x2: 515.6,
    y2: 215.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 501.1,
    y1: 209.58,
    x2: 507.4,
    y2: 209.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 492.65,
    y1: 203.93,
    x2: 498.99,
    y2: 203.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 484,
    y1: 198.6,
    x2: 490.39,
    y2: 198.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 475.17,
    y1: 193.59,
    x2: 481.59,
    y2: 193.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 466.15,
    y1: 188.9,
    x2: 472.62,
    y2: 188.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 456.98,
    y1: 184.55,
    x2: 463.48,
    y2: 184.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 447.66,
    y1: 180.52,
    x2: 454.18,
    y2: 180.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 438.2,
    y1: 176.83,
    x2: 444.75,
    y2: 176.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 428.62,
    y1: 173.48,
    x2: 435.19,
    y2: 173.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 418.92,
    y1: 170.47,
    x2: 425.51,
    y2: 170.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 409.13,
    y1: 167.8,
    x2: 415.73,
    y2: 167.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 399.25,
    y1: 165.47,
    x2: 405.86,
    y2: 165.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 389.29,
    y1: 163.49,
    x2: 395.91,
    y2: 163.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 379.28,
    y1: 161.87,
    x2: 385.9,
    y2: 161.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 369.22,
    y1: 160.6,
    x2: 375.83,
    y2: 160.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 359.12,
    y1: 159.68,
    x2: 365.73,
    y2: 159.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 348.99,
    y1: 159.13,
    x2: 355.59,
    y2: 159.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 338.86,
    y1: 158.93,
    x2: 345.45,
    y2: 158.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 328.73,
    y1: 159.1,
    x2: 335.3,
    y2: 159.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 318.61,
    y1: 159.64,
    x2: 325.16,
    y2: 159.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 308.52,
    y1: 160.55,
    x2: 315.05,
    y2: 160.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 298.48,
    y1: 161.83,
    x2: 304.97,
    y2: 161.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 288.49,
    y1: 163.5,
    x2: 294.95,
    y2: 163.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 278.59,
    y1: 165.59,
    x2: 285.01,
    y2: 165.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 268.79,
    y1: 168.13,
    x2: 275.17,
    y2: 168.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 259.15,
    y1: 171.13,
    x2: 265.45,
    y2: 171.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 249.69,
    y1: 174.65,
    x2: 255.88,
    y2: 174.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 240.45,
    y1: 178.7,
    x2: 246.53,
    y2: 178.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 231.48,
    y1: 183.31,
    x2: 237.43,
    y2: 183.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 222.86,
    y1: 188.53,
    x2: 228.66,
    y2: 188.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 214.66,
    y1: 194.37,
    x2: 220.27,
    y2: 194.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 206.96,
    y1: 200.84,
    x2: 212.37,
    y2: 200.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 199.84,
    y1: 207.94,
    x2: 205.02,
    y2: 207.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 193.4,
    y1: 215.67,
    x2: 198.32,
    y2: 215.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 187.78,
    y1: 224,
    x2: 192.39,
    y2: 224,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 183.01,
    y1: 232.86,
    x2: 187.32,
    y2: 232.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 179.12,
    y1: 242.16,
    x2: 183.11,
    y2: 242.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 176.1,
    y1: 251.79,
    x2: 179.78,
    y2: 251.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 173.95,
    y1: 261.66,
    x2: 177.33,
    y2: 261.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 172.67,
    y1: 271.7,
    x2: 175.74,
    y2: 271.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 172.24,
    y1: 281.82,
    x2: 175,
    y2: 281.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 172.44,
    y1: 291.96,
    x2: 175.32,
    y2: 291.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 173.45,
    y1: 302.04,
    x2: 176.54,
    y2: 302.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 175.31,
    y1: 311.99,
    x2: 178.62,
    y2: 311.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 178.02,
    y1: 321.73,
    x2: 181.54,
    y2: 321.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 181.58,
    y1: 331.17,
    x2: 185.32,
    y2: 331.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 186,
    y1: 340.25,
    x2: 189.94,
    y2: 340.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 191.27,
    y1: 348.85,
    x2: 195.4,
    y2: 348.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 197.37,
    y1: 356.88,
    x2: 201.67,
    y2: 356.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 204.27,
    y1: 364.23,
    x2: 208.72,
    y2: 364.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 211.91,
    y1: 370.85,
    x2: 216.47,
    y2: 370.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 220.16,
    y1: 376.67,
    x2: 224.81,
    y2: 376.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 228.94,
    y1: 381.68,
    x2: 233.66,
    y2: 381.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 238.16,
    y1: 385.87,
    x2: 242.9,
    y2: 385.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 247.72,
    y1: 389.23,
    x2: 252.48,
    y2: 389.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 257.55,
    y1: 391.75,
    x2: 262.29,
    y2: 391.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 267.57,
    y1: 393.43,
    x2: 272.27,
    y2: 393.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 277.71,
    y1: 394.27,
    x2: 282.35,
    y2: 394.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 287.89,
    y1: 394.28,
    x2: 292.45,
    y2: 394.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 298.04,
    y1: 393.4,
    x2: 302.5,
    y2: 393.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 308.1,
    y1: 391.65,
    x2: 312.43,
    y2: 391.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 317.97,
    y1: 389.02,
    x2: 322.14,
    y2: 389.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 327.56,
    y1: 385.48,
    x2: 331.55,
    y2: 385.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 336.78,
    y1: 381.05,
    x2: 340.56,
    y2: 381.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 345.53,
    y1: 375.91,
    x2: 348.53,
    y2: 375.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 1031.56,
    y1: 590.1,
    x2: 963.97,
    y2: 643.17,
    gradientTransform: "translate(-43.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1779.68,
    y1: 590.31,
    x2: 1775.98,
    y2: 622.63,
    gradientTransform: "matrix(-1, 0, 0, 1, 2727.85, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 1842.55,
    y1: 605.39,
    x2: 1776.58,
    y2: 657.19,
    gradientTransform: "matrix(-1, 0, 0, 1, 2727.85, 0)",
    xlinkHref: "#linear-gradient-139"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1818.69,
    y1: 594.44,
    x2: 1815.23,
    y2: 624.67,
    gradientTransform: "matrix(-1, 0, 0, 1, 2727.85, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 937.91,
    y1: 365.51,
    x2: 936.96,
    y2: 408.15,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -25.47,
    y1: 470.17,
    x2: -55.02,
    y2: 495.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 916.01, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 864.78,
    y1: 379.61,
    x2: 866,
    y2: 399.45,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 962.38,
    y1: 363.22,
    x2: 919.43,
    y2: 374.36,
    gradientTransform: "translate(56.19 -117.3) rotate(7.45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: -4130.38,
    y1: -3710.54,
    x2: -4109.92,
    y2: -3731.54,
    gradientTransform: "matrix(-0.96, -0.29, -0.29, 0.96, -4063.86, 2774.56)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 675.65,
    y1: 386.88,
    x2: 687.7,
    y2: 386.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 670.03,
    y1: 400.54,
    x2: 693.25,
    y2: 400.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 709.44,
    y1: 398.6,
    x2: 824.06,
    y2: 398.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 710.61,
    y1: 409.82,
    x2: 773.24,
    y2: 409.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 777.15,
    y1: 409.82,
    x2: 824.12,
    y2: 409.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 262.29,
    y1: 390.11,
    x2: 289.11,
    y2: 390.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 227.88,
    y1: 485.69,
    x2: 318.95,
    y2: 485.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 205.22,
    y1: 577.56,
    x2: 219.72,
    y2: 577.56,
    xlinkHref: "#linear-gradient-153"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1340.5,
    y1: 600.53,
    x2: 1348.57,
    y2: 600.53,
    gradientTransform: "translate(-1198.53)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 1311.38,
    y1: 600.11,
    x2: 1318.36,
    y2: 600.11,
    gradientTransform: "translate(-1198.53)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 1229.61,
    y1: 622.15,
    x2: 1160.88,
    y2: 749.1,
    gradientTransform: "translate(-1198.53)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 1373.74,
    y1: 389.79,
    x2: 1415,
    y2: 389.79,
    gradientTransform: "translate(-1198.53)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 7139.43,
    y1: 382.87,
    x2: 7167.12,
    y2: 445.88,
    gradientTransform: "matrix(-1, 0, 0, 1, 7346.71, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 181.22,
    y1: 401.83,
    x2: 241.35,
    y2: 333.1,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 1202.6,
    y1: 607.53,
    x2: 1133.88,
    y2: 734.48,
    gradientTransform: "translate(-1198.53)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 135.35,
    y1: 391.2,
    x2: 126.76,
    y2: 456.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: -4127.31,
    y1: 8.14,
    x2: -4155.95,
    y2: -44.83,
    gradientTransform: "matrix(0.75, -0.67, 0.67, 0.75, 4728.46, -1834.19)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: -4132.87,
    y1: 11.15,
    x2: -4161.51,
    y2: -41.83,
    gradientTransform: "matrix(0.75, -0.67, 0.67, 0.75, 4728.46, -1834.19)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 1326.06,
    y1: 477.44,
    x2: 1283.55,
    y2: 443.43,
    gradientTransform: "translate(-1198.53)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12,276.18c12.42,22,32.16,40.45,47.36,61C103.25,396.55,57.54,466,77.59,530c17.47,55.76,90.15,70.71,143.27,73,89.51,3.81,178.92-1.91,265.23-26.18,59.88-16.85,119.85-38.91,183-40.24,64.53-1.37,125.23,24.54,187.57,36.79,68.45,13.45,150.32-1.15,166.82-77.6,10.23-47.35-17.29-91-19.87-137.59-3.41-61.73,58.12-95.6,66.09-153.31,5-36.38-13.74-68.89-38.21-95.21-25.83-27.78-60.55-52.32-100.39-54.6C889.42,52.69,852.26,74.55,813.34,85,704,114.32,641.87,16.49,541.21,2.84,495.82-3.31,440-.39,398.81,20.74,360.49,40.39,341.89,84,298.9,96.86c-45.51,13.57-87.14-13.55-130.38-22.21-44.75-9-87.08,6.95-115.09,41.85C26.28,150.33-3.11,194.9.27,239.57,1.29,253.13,5.69,265.1,12,276.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M285.8,589.61c-26.68,5.33-60.75-23.76-71.73-55.54-11.3-32.7,9.41-46.41,9.25-91.79-.18-51.56-27-59.33-44.73-128.82-4-15.68-27.17-106.41,1.54-123.42,26.54-15.72,101.09,29.41,114.16,87.17,9.32,41.18-19.49,58.48-8.49,106.45,9.66,42.09,35,42.69,44.74,83.3C342.38,516.4,320.84,582.6,285.8,589.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.87,602.1C291.06,546.55,277,460.86,264,398.75c-14.12-67.24-30.14-122.09-30.3-122.64l-2.22.65c.16.55,16.16,55.32,30.26,122.48,13,61.93,27,147.34,19.84,202.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.07,583.41c35-18.24,47-80.87,27.09-101.22-13.44-13.75-32.72.71-51.32-13.54-23.75-18.2-6.28-52.48-25-96.94-15.89-37.84-54-73.64-76.27-66.29-23.31,7.69-35.59,64.74-15.68,99.08,13,22.33,32.77,23.42,37.07,44.19,5,24.1-19.12,35.09-19.25,58.45C131.52,549.1,208.77,607.53,255.07,583.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.19,599.45a1.44,1.44,0,0,0,1.28-2.05c-46.41-95.62-60-206.55-60.14-207.66a1.43,1.43,0,0,0-2.84.34c.14,1.12,13.8,112.52,60.41,208.56A1.44,1.44,0,0,0,236.19,599.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141,418.47a.71.71,0,0,0,.42-.14.68.68,0,0,0,.12-1c-14.65-18.8-30.88-47-25-74.84,3.48-16.55,13.28-25.19,13.38-25.27a.69.69,0,0,0,.07-1,.67.67,0,0,0-1-.07c-.42.36-10.25,9-13.82,26-3.28,15.62-1.56,41.48,25.3,76A.67.67,0,0,0,141,418.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M258.23,575.06a.68.68,0,0,0,.56-.3c22.51-32.85,30.19-58.23,22.82-75.44-6.56-15.3-23.1-18.15-23.27-18.18a.68.68,0,0,0-.78.56.69.69,0,0,0,.56.79c.16,0,16,2.77,22.24,17.38,7.16,16.75-.47,41.69-22.69,74.12a.68.68,0,0,0,.18,1A.66.66,0,0,0,258.23,575.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M790.42,589.61c26.69,5.33,60.76-23.76,71.74-55.54,11.3-32.7-9.42-46.41-9.26-91.79.18-51.56,27-59.33,44.74-128.82,4-15.68,27.16-106.41-1.54-123.42-26.54-15.72-101.1,29.41-114.16,87.17-9.32,41.18,19.48,58.48,8.48,106.45-9.65,42.09-35,42.69-44.74,83.3C733.85,516.4,755.39,582.6,790.42,589.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M792.36,602.1c-7.19-55.55,6.84-141.24,19.88-203.35,14.11-67.24,30.14-122.09,30.3-122.64l2.22.65c-.16.55-16.16,55.32-30.26,122.48-13,61.93-27,147.34-19.85,202.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M821.15,583.41c-35-18.24-47-80.87-27.08-101.22,13.44-13.75,32.72.71,51.32-13.54,23.74-18.2,6.28-52.48,24.94-96.94,15.89-37.84,54-73.64,76.27-66.29,23.32,7.69,35.59,64.74,15.69,99.08-12.95,22.33-32.77,23.42-37.07,44.19-5,24.1,19.11,35.09,19.25,58.45C944.7,549.1,867.46,607.53,821.15,583.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M840,599.45a1.38,1.38,0,0,1-.62-.15,1.41,1.41,0,0,1-.66-1.9c46.4-95.62,60-206.55,60.14-207.66a1.43,1.43,0,0,1,2.83.34c-.13,1.12-13.8,112.52-60.41,208.56A1.41,1.41,0,0,1,840,599.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M935.24,418.47a.75.75,0,0,1-.42-.14.69.69,0,0,1-.12-1c14.65-18.8,30.89-47,25-74.84-3.48-16.55-13.27-25.19-13.37-25.27a.68.68,0,1,1,.89-1c.42.36,10.24,9,13.82,26,3.28,15.62,1.56,41.48-25.3,76A.69.69,0,0,1,935.24,418.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M818,575.06a.71.71,0,0,1-.57-.3c-22.51-32.85-30.18-58.23-22.81-75.44,6.55-15.3,23.1-18.15,23.27-18.18a.68.68,0,0,1,.78.56.69.69,0,0,1-.57.79c-.15,0-16,2.77-22.24,17.38-7.16,16.75.48,41.69,22.7,74.12a.69.69,0,0,1-.56,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247.18,264V556.79c0,21.54,18.93,39,42.27,39H781c23.34,0,42.26-17.47,42.26-39V264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M679.57,176.87l-125-75.61a36.76,36.76,0,0,0-38.75,0l-125,75.58L246.58,264.15l144.33,87.09,144.33,87.08,144.33-87.18,144.33-87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M258.47,583.15a1,1,0,0,1-.76-1.69l180-202.53a1,1,0,0,1,1.51,1.35l-180,202.53A1,1,0,0,1,258.47,583.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M812,583.15a1,1,0,0,1-.76-.34l-180-202.53a1,1,0,1,1,1.51-1.35l180,202.53a1,1,0,0,1-.08,1.43A1,1,0,0,1,812,583.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M717.13,455.75s-5.93-7.12,2.14-11.5,20.75.42,22.35,9.75,9.62,3.79,13.12,1.75,13.26-4.81,15.74,5.83c1,4.21-.26,9.6,1.56,13.52,2.52,5.4,10.72,4,15.2,6.07,5.82,2.68,8.86,7.87,5.83,13.93-4.67,9.33-13.85,15.26-8.89,23.37s-15,26.33-21.86,9.42-17.49-14-26.09-15.11-13-8.5-10.64-16.08-.73-12.09-3.94-15.3S707.66,464.35,717.13,455.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M704.65,546.46a37.85,37.85,0,0,0-13.76,5.87,3.64,3.64,0,0,0-1.6,3.47c.87,6.9,4.46,29.24,16.27,51.07a5.43,5.43,0,0,1,.53,3.77L704,620.19l-3.81,3.57H710l6.53-17.67-2.8-.88a5.28,5.28,0,0,1-3.68-5l-.33-19A21.57,21.57,0,0,0,704.58,567l15.66-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M696.4,625.49c-.89,1.16,9.61,2.71,14.92.15,0,0,7.36-12.8,7.36-19.39,0,0-.59-1.34-4.91-1,0,0-2.47,15.16-5.07,16.85s-7.3.18-7.3.18S697.72,623.76,696.4,625.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M718.26,567.32c-.08-.15-16.86-2-16.86-2a38.68,38.68,0,0,1-1.17,12.12c-1.71,7-26.35,37.45-26.35,37.45l2.58,8.19a41.54,41.54,0,0,1-23.57,1.42l16-9.61s15-51,24.16-60.16l16.82-5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M755.89,537.61s9.66,14.38,10.46,20.94-2.65,9.22-12.79,9.66-37.22.43-37.22.43l-23.11-19.75s16.84-6,21.22-7.71S755.89,537.61,755.89,537.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M675.49,620.3s2.78,2.7.9,5.69c0,0-22,3.91-28,2.14,0,0,1.24-2.84,8-6.07l-.5.39a.8.8,0,0,0,.53,1.44C660.83,623.64,670,622.82,675.49,620.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M729.74,535.71S718.49,525,713,517.89a15,15,0,0,1-2.55-13.56c2.53-8.52,7-17.35,7.43-18.72.63-2.11,13.25-2,13.25-2s24.84,16.12,34.6,43.42l-11,3.42s-6.49-10.88-12.89-17.8c0,0,11.08,14.65,11.47,20.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M716.31,473.84c.13.44,3.42,11.36,3.68,11.58s7.22.61,10.5-1.64l-5.56-11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M721.72,450.9s-6,2.51-10,11.1-1,12.57,2.76,13.11S724,475.57,730,470,729.45,447.92,721.72,450.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M725.93,465.43s4.48-12.57-6.66-12.72l-2.63,1.83s-4.09-7,2.63-10.29a14.26,14.26,0,0,1,19.58,8.68c2.86,9,1.19,14.88-3.56,19.21s-6.72-.58-6.72-.58,2.59-4.05,1.54-6.21-3.48.44-3.48.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M724.74,467.44s2.27-6.48,5.3-3.9-2.46,6-4.61,7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M706.81,536.5l8.27-8,11.44,4.83s11.39,1.77,17.91,0L751,531.6,765.68,527l2.31,6.54a3.94,3.94,0,0,1-1.44,4.53,25.14,25.14,0,0,1-3.72,2.31c-1.94.85-47.81-.58-47.81-.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M766.89,466.2l-.39-.05c.34-3.12-.18-5.21-1.59-6.37-2.79-2.3-8.58-.5-13.7,1.09a33.9,33.9,0,0,1-6.74,1.66,3.94,3.94,0,0,1-3.13-1,5.35,5.35,0,0,1-1.28-3.73l.39,0a5.11,5.11,0,0,0,1.17,3.43,3.52,3.52,0,0,0,2.82.92,33.28,33.28,0,0,0,6.66-1.63c5.2-1.62,11.11-3.46,14.06-1C766.68,460.73,767.25,462.93,766.89,466.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M779.07,513.3c-.92-3.79,1.56-7,4.44-10.69,2.07-2.66,4.42-5.68,5.68-9.31a5.34,5.34,0,0,0-.39-4.73c-2.68-4.37-11.57-5.64-11.66-5.65l.05-.39c.37.05,9.17,1.31,11.95,5.84a5.72,5.72,0,0,1,.42,5.06c-1.28,3.69-3.65,6.73-5.74,9.42-2.81,3.62-5.25,6.75-4.37,10.36Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 734.63,
    y: 577.87,
    width: 4.36,
    height: 47.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M755.89,625.9H717.73a2.84,2.84,0,0,1,2.84-2.84h32.48a2.84,2.84,0,0,1,2.84,2.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 713.57,
    y: 567.32,
    width: 47.98,
    height: 13.61,
    rx: 4.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M738.11,540.26H738l-48,0a2.15,2.15,0,1,1,0-4.29l48,.05a2.15,2.15,0,0,1,.1,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M646.9,496.7h40a7.61,7.61,0,0,1,6.89,4.37l18.47,39.17H662.56a4.63,4.63,0,0,1-4.31-2.93l-14.32-36.24A3.19,3.19,0,0,1,646.9,496.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M805.17,542a1.77,1.77,0,0,0-.42-1.53,2,2,0,0,0-1.53-.67H603a2.32,2.32,0,0,0-1.92,1,2,2,0,0,0-.15,2.05l2.17,4.4a3.05,3.05,0,0,0,2.76,1.65h196a2.27,2.27,0,0,0,2.26-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M614.24,634.78a1.67,1.67,0,0,1-.69-.14,1.81,1.81,0,0,1-.92-2.37l36.84-87.64a1.75,1.75,0,0,1,2.31-.94,1.81,1.81,0,0,1,.92,2.36l-36.85,87.64A1.73,1.73,0,0,1,614.24,634.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M655.75,634.78a1.76,1.76,0,0,1-1.62-1.09l-36.84-87.64a1.81,1.81,0,0,1,.92-2.36,1.75,1.75,0,0,1,2.31.94l36.84,87.64a1.82,1.82,0,0,1-.92,2.37A1.67,1.67,0,0,1,655.75,634.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M759.34,634.78a1.67,1.67,0,0,1-.69-.14,1.82,1.82,0,0,1-.92-2.37l36.84-87.64a1.75,1.75,0,0,1,2.31-.94,1.81,1.81,0,0,1,.92,2.36L761,633.69A1.76,1.76,0,0,1,759.34,634.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M800.85,634.78a1.73,1.73,0,0,1-1.61-1.09l-36.85-87.64a1.81,1.81,0,0,1,.92-2.36,1.75,1.75,0,0,1,2.31.94l36.84,87.64a1.81,1.81,0,0,1-.92,2.37A1.67,1.67,0,0,1,800.85,634.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M714.45,122.37H311.18a13.33,13.33,0,0,0-13,13.28V462.91H772.3V181.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M772.07,181.13l-52.91.46a4.73,4.73,0,0,1-3.5-1.52,4.92,4.92,0,0,1-1.09-3.74V122.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M639.84,276.31a93.3,93.3,0,0,1-5.9,33.77q-5.9,15.3-16.66,24a38.57,38.57,0,0,1-25,8.72,31.13,31.13,0,0,1-16.79-4.55,26.13,26.13,0,0,1-10.51-12h-2q-13.85,16.53-35.24,16.53-22.68,0-35.76-13.65t-13.07-37.36q0-27,17.17-43.57t44.86-16.53a155.06,155.06,0,0,1,24.28,2.11A134.35,134.35,0,0,1,587,238.88l-2.95,62.67q0,17.82,9.74,17.82,8.2,0,13.07-12t4.87-31.33q0-20.64-8.59-36.46A58.23,58.23,0,0,0,579,215.43q-15.59-8.33-35.57-8.33-25.89,0-45,10.64a71.09,71.09,0,0,0-29.28,30.69Q459,268.49,459,294.76q0,35.37,18.9,54.27t54.79,18.91a165.86,165.86,0,0,0,29.86-3,198.69,198.69,0,0,0,32-8.78v24.6q-27.44,11.67-60.88,11.67-48.69,0-75.93-25.64t-27.23-71.25q0-31.65,13.9-57.48a101,101,0,0,1,39.6-40.5q25.69-14.67,59.15-14.67,28.18,0,50.36,11.53a81.82,81.82,0,0,1,34.22,32.81Q639.84,248.49,639.84,276.31Zm-131.24,16q0,27,22,27,11.54,0,17.55-8.14t7.31-26.47l1.66-28.32A70.09,70.09,0,0,0,542.44,255q-16,0-24.93,10T508.6,292.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M802.2,120.27a90.16,90.16,0,0,1,140.3-76l5.13-5.2a2.64,2.64,0,0,1,4.42,1.15l9,32.59a2.63,2.63,0,0,1-3.21,3.25l-32.7-8.53a2.64,2.64,0,0,1-1.21-4.41l5.77-5.87a72,72,0,1,0,35,62.39,2.92,2.92,0,0,1,2.6-2.94l12.6-.15a2.65,2.65,0,0,1,1.79,1l.11.11a3.46,3.46,0,0,1,.78,2.21,90.16,90.16,0,0,1-180.32.38Zm157-46.74a1.1,1.1,0,0,0,0-.18l-9-32.58a.66.66,0,0,0-.49-.48.68.68,0,0,0-.66.18l-6.27,6.35-.67-.46a88.14,88.14,0,1,0,38.49,73.52h0a1.75,1.75,0,0,0-.22-.83l-.11-.11a3.23,3.23,0,0,0-.45-.4l-12.53.14c-.26,0-.66.53-.67,1a74.26,74.26,0,1,1-34.84-63.42l1,.64-7.48,7.61a.68.68,0,0,0-.18.66.69.69,0,0,0,.49.49l32.7,8.53A.72.72,0,0,0,959,74,.73.73,0,0,0,959.16,73.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M864.82,137h-26V131.5l9.33-9.43c2.76-2.83,4.56-4.8,5.41-5.89a12.55,12.55,0,0,0,1.83-3,7.74,7.74,0,0,0,.56-2.89,4.22,4.22,0,0,0-1.23-3.33,4.8,4.8,0,0,0-3.3-1.1,9.47,9.47,0,0,0-4.19,1,21.85,21.85,0,0,0-4.24,2.83l-4.28-5.06a28.4,28.4,0,0,1,4.55-3.31,16.62,16.62,0,0,1,4-1.48,20,20,0,0,1,4.77-.53,14.13,14.13,0,0,1,6.16,1.28,9.81,9.81,0,0,1,4.14,3.55,9.51,9.51,0,0,1,1.47,5.24,12.87,12.87,0,0,1-.9,4.82,18.12,18.12,0,0,1-2.8,4.61,67.58,67.58,0,0,1-6.67,6.74l-4.78,4.5v.35h16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M895.37,129.26H890.9V137h-7.68v-7.7H867.36v-5.47l16.29-24h7.25v23.36h4.47Zm-12.15-6.1v-6.3c0-1.06,0-2.58.13-4.58s.15-3.16.2-3.48h-.2a27.67,27.67,0,0,1-2.27,4.06l-6.81,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M917.43,99.8,903.58,137h-7L910.39,99.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M923.46,137l13.95-30.5H919.09V99.85h26.66v4.93L931.69,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M939.15,285.65l.25,3v0a.54.54,0,0,0,.57.48.53.53,0,0,0,.48-.57h0l-.29-3.05a.51.51,0,0,0-.55-.46.51.51,0,0,0-.46.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M939.67,295.74v3a.56.56,0,0,0,.57.57.57.57,0,0,0,.58-.57h0l0-3.06a.56.56,0,0,0-.56-.56.57.57,0,0,0-.56.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M939.32,305.82l-.27,3v0a.63.63,0,0,0,.57.68.62.62,0,0,0,.68-.57h0l.25-3a.62.62,0,0,0-.56-.66.61.61,0,0,0-.66.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M938.12,315.84l-.52,3h0a.67.67,0,0,0,.55.79.69.69,0,0,0,.79-.55h0l.49-3a.67.67,0,0,0-.55-.76.66.66,0,0,0-.76.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M936.11,325.72l-.75,2.93h0a.72.72,0,0,0,.52.89.73.73,0,0,0,.89-.52h0l.73-3a.71.71,0,0,0-1.38-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M933.33,335.41l-1,2.86v0a.78.78,0,0,0,1.48.51h0l1-2.91a.77.77,0,0,0-1.46-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M929.82,344.86l-1.2,2.78v0a.83.83,0,0,0,1.53.66h0l1.18-2.83a.81.81,0,0,0-.44-1.07.82.82,0,0,0-1.07.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M925.6,354l-1.4,2.68v0a.89.89,0,1,0,1.57.82h0l1.39-2.73a.88.88,0,0,0-.39-1.17.86.86,0,0,0-1.16.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M920.71,362.82l-1.59,2.57,0,0a.94.94,0,0,0,1.6,1h0l1.58-2.62a.92.92,0,0,0-1.57-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M915.18,371.24l-1.78,2.44v0a1,1,0,0,0,1.6,1.17h0l1.78-2.5a1,1,0,0,0-1.59-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M909,379.22l-1.95,2.3,0,0a1,1,0,0,0,1.59,1.35h0l2-2.36a1,1,0,0,0-.13-1.44,1,1,0,0,0-1.44.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M902.33,386.71l-2.13,2.15h0a1.1,1.1,0,0,0,1.56,1.55h0l2.14-2.21a1.08,1.08,0,0,0-1.54-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M895.06,393.66l-2.28,2h0a1.15,1.15,0,1,0,1.5,1.74h0l2.3-2a1.13,1.13,0,0,0-1.49-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M887.27,400l-2.42,1.78,0,0a1.2,1.2,0,1,0,1.42,1.93h0l2.46-1.83A1.19,1.19,0,0,0,887.3,400Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M879,405.73l-2.57,1.58h0a1.24,1.24,0,1,0,1.29,2.11h0l2.61-1.63a1.23,1.23,0,0,0-1.3-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M870.32,410.74l-2.68,1.35,0,0a1.27,1.27,0,0,0,1.14,2.26h0l2.73-1.4a1.26,1.26,0,0,0-1.14-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M861.24,415l-2.79,1.12h0a1.3,1.3,0,0,0,1,2.41h0l2.85-1.16a1.29,1.29,0,0,0-1-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M851.82,418.44l-2.87.89h0a1.32,1.32,0,1,0,.78,2.53h0l2.93-.93a1.31,1.31,0,0,0,.86-1.65,1.33,1.33,0,0,0-1.65-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M842.16,421.14l-2.94.66h0a1.35,1.35,0,1,0,.59,2.64h0l3-.7a1.34,1.34,0,0,0-.6-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M832.31,423.09l-3,.44h0a1.39,1.39,0,1,0,.41,2.74h0l3-.47a1.38,1.38,0,0,0-.41-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M822.34,424.31l-3,.22h0a1.41,1.41,0,0,0,.21,2.81h0l3.06-.25a1.4,1.4,0,1,0-.22-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M812.32,424.82l-3,0h0a1.44,1.44,0,1,0,0,2.88h0l3.07,0a1.44,1.44,0,1,0,0-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M802.27,424.67l-3-.17h0a1.48,1.48,0,0,0-1.55,1.39,1.46,1.46,0,0,0,1.39,1.55h0l3.07.16a1.46,1.46,0,0,0,.16-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M792.25,423.89l-3-.35h0a1.5,1.5,0,1,0-.35,3h0l3.05.34a1.49,1.49,0,0,0,.34-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M782.29,422.51l-3-.52h0a1.53,1.53,0,0,0-.53,3h0l3,.52a1.52,1.52,0,0,0,.52-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M772.42,420.57l-2.93-.68h0a1.56,1.56,0,0,0-.71,3h0l3,.68a1.55,1.55,0,0,0,.7-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M762.68,418.1l-2.91-.84h0a1.59,1.59,0,0,0-.89,3.06h0l3,.84a1.58,1.58,0,0,0,.87-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M753.06,415.13l-2.85-1h0a1.62,1.62,0,0,0-1,3.06h0l2.9,1a1.61,1.61,0,0,0,1-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M743.61,411.68l-2.8-1.13h0a1.66,1.66,0,0,0-2.14.92,1.64,1.64,0,0,0,.92,2.14h0l2.85,1.12a1.64,1.64,0,0,0,1.21-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M734.33,407.77l-2.74-1.25h0a1.68,1.68,0,1,0-1.4,3.05h0l2.79,1.26a1.67,1.67,0,1,0,1.38-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M725.25,403.44l-2.69-1.39h0a1.7,1.7,0,1,0-1.56,3h0l2.74,1.39a1.69,1.69,0,0,0,1.54-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M716.37,398.69l-2.62-1.5h0a1.72,1.72,0,0,0-1.7,3h0l2.66,1.51a1.72,1.72,0,0,0,1.7-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M707.7,393.58l-2.57-1.6h0a1.72,1.72,0,1,0-1.82,2.93h0l2.6,1.62a1.73,1.73,0,0,0,1.82-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M699.21,388.13l-2.5-1.69h0a1.74,1.74,0,0,0-1.94,2.88h0l2.54,1.71a1.74,1.74,0,1,0,1.94-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M690.93,382.39l-2.45-1.78h0a1.75,1.75,0,0,0-2.05,2.83h0l2.48,1.8a1.75,1.75,0,0,0,2.05-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M682.83,376.38l-2.4-1.86h0a1.76,1.76,0,0,0-2.15,2.78h0l2.43,1.86a1.75,1.75,0,1,0,2.14-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M674.91,370.12l-2.34-1.92h0a1.77,1.77,0,1,0-2.24,2.73h0l2.37,1.94a1.76,1.76,0,1,0,2.23-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M667.16,363.65l-2.29-2h0a1.77,1.77,0,1,0-2.32,2.68h0l2.32,2a1.77,1.77,0,1,0,2.31-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M659.57,357l-2.25-2h0a1.79,1.79,0,1,0-2.4,2.65h0l2.27,2a1.78,1.78,0,1,0,2.39-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M652.13,350.15l-2.21-2.08h0a1.8,1.8,0,0,0-2.46,2.62h0l2.23,2.09a1.79,1.79,0,0,0,2.45-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M644.82,343.17l-2.18-2.12h0a1.8,1.8,0,1,0-2.52,2.58h0l2.19,2.13a1.8,1.8,0,1,0,2.51-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M637.61,336.07l-2.14-2.16h0a1.81,1.81,0,1,0-2.57,2.56h0l2.16,2.16a1.81,1.81,0,0,0,2.56-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M630.5,328.86l-2.12-2.18h0a1.83,1.83,0,0,0-2.62,2.55h0l2.14,2.18a1.82,1.82,0,1,0,2.6-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M623.47,321.57l-2.09-2.21a1.84,1.84,0,1,0-2.67,2.53h0l2.11,2.21a1.83,1.83,0,1,0,2.64-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M616.51,314.21,614.43,312a1.85,1.85,0,1,0-2.7,2.52h0l2.09,2.22a1.84,1.84,0,1,0,2.68-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M609.58,306.8l-2.06-2.23a1.85,1.85,0,1,0-2.72,2.52h0l2.08,2.23a1.85,1.85,0,1,0,2.7-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M602.69,299.37l-2.07-2.24a1.86,1.86,0,0,0-2.74,2.53h0L600,301.9a1.86,1.86,0,0,0,2.73-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M595.79,291.92l-2.07-2.23a1.87,1.87,0,0,0-2.74,2.54h0l2.07,2.22a1.87,1.87,0,1,0,2.74-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M588.89,284.48l-2.08-2.22a1.88,1.88,0,0,0-2.75,2.57h0l2.08,2.22a1.88,1.88,0,1,0,2.75-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M581.94,277.08l-2.09-2.22a1.89,1.89,0,0,0-2.75,2.6h0l2.1,2.2a1.89,1.89,0,1,0,2.74-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M575,269.71l-2.12-2.19a1.9,1.9,0,1,0-2.74,2.63h0l2.11,2.18h0a1.9,1.9,0,1,0,2.74-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M567.87,262.41l-2.13-2.17a1.91,1.91,0,1,0-2.73,2.68h0l2.13,2.16h0a1.91,1.91,0,1,0,2.72-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M560.71,255.19l-2.17-2.14a1.92,1.92,0,0,0-2.7,2.73h0l2.16,2.13h0a1.92,1.92,0,0,0,2.69-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M553.44,248.08l-2.2-2.11a1.93,1.93,0,0,0-2.68,2.79h0l2.2,2.09h0a1.93,1.93,0,0,0,2.66-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M546,241.1,543.78,239a1.92,1.92,0,1,0-2.6,2.83h0l2.23,2h0A1.92,1.92,0,0,0,546,241.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M538.48,234.26l-2.29-2a1.92,1.92,0,0,0-2.54,2.88h0l2.27,2h0a1.92,1.92,0,0,0,2.54-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M530.77,227.6l-2.34-2a1.91,1.91,0,1,0-2.45,2.93h0l2.31,1.94h0a1.91,1.91,0,0,0,2.45-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M522.9,221.14l-2.4-1.9a1.9,1.9,0,0,0-2.36,3h0l2.37,1.88h0a1.9,1.9,0,1,0,2.37-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M514.84,214.89l-2.46-1.82a1.89,1.89,0,1,0-2.26,3h0l2.42,1.81h0a1.9,1.9,0,0,0,2.27-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M506.58,208.9l-2.51-1.75a1.89,1.89,0,1,0-2.15,3.1h0l2.48,1.73h0a1.89,1.89,0,1,0,2.17-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M498.13,203.18l-2.58-1.66a1.88,1.88,0,1,0-2,3.16h0l2.54,1.64h0a1.88,1.88,0,0,0,2-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M489.47,197.76l-2.64-1.56a1.88,1.88,0,0,0-1.91,3.23h0l2.6,1.54h0a1.87,1.87,0,1,0,1.92-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M480.62,192.68l-2.7-1.47a1.87,1.87,0,1,0-1.78,3.28h0l2.65,1.45h0a1.87,1.87,0,0,0,1.79-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M471.58,187.92l-2.74-1.37a1.86,1.86,0,1,0-1.65,3.33h0l2.71,1.35h0a1.86,1.86,0,0,0,1.67-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M462.39,183.49l-2.79-1.27a1.86,1.86,0,0,0-1.53,3.38h0l2.75,1.26h0a1.85,1.85,0,1,0,1.54-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M453,179.39l-2.84-1.16a1.84,1.84,0,0,0-1.4,3.41h0l2.79,1.15h0a1.85,1.85,0,0,0,1.41-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M443.55,175.64l-2.88-1.06A1.83,1.83,0,1,0,439.4,178h0l2.83,1.05h0a1.84,1.84,0,0,0,1.28-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M433.93,172.22l-2.91-1a1.83,1.83,0,1,0-1.15,3.47h0l2.87.95h0a1.83,1.83,0,0,0,1.15-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M424.19,169.14l-2.94-.85a1.82,1.82,0,1,0-1,3.49h0l2.9.85h0a1.82,1.82,0,1,0,1-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M414.36,166.41l-3-.75a1.82,1.82,0,1,0-.89,3.52h0l2.93.75h0a1.82,1.82,0,0,0,.9-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M404.43,164l-3-.65a1.81,1.81,0,1,0-.77,3.53h0l3,.65h0a1.81,1.81,0,1,0,.77-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M394.43,162l-3-.54a1.8,1.8,0,1,0-.63,3.54h0l3,.53h0a1.8,1.8,0,0,0,.64-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M384.36,160.31l-3-.43a1.79,1.79,0,1,0-.51,3.54h0l3,.43h0a1.79,1.79,0,1,0,.52-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M374.24,159l-3.05-.32a1.79,1.79,0,0,0-.38,3.55h0l3,.33h0a1.79,1.79,0,0,0,.39-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M364.08,158,361,157.8a1.77,1.77,0,1,0-.25,3.54h0l3,.22h0a1.78,1.78,0,0,0,.26-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M353.89,157.41l-3.06-.11a1.77,1.77,0,1,0-.13,3.54h0l3,.11h0a1.77,1.77,0,0,0,.13-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M343.68,157.17h-3.06a1.76,1.76,0,0,0,0,3.52h3.06a1.77,1.77,0,0,0,0-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M333.48,157.29l-3.06.11a1.76,1.76,0,0,0,.12,3.51h0l3-.11h0a1.76,1.76,0,1,0-.12-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M323.29,157.79l-3.06.22a1.74,1.74,0,1,0,.25,3.48h0l3-.21h0a1.75,1.75,0,0,0-.25-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M313.12,158.65l-3.05.33a1.74,1.74,0,1,0,.38,3.46h0l3-.32h0a1.74,1.74,0,1,0-.37-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M303,159.89l-3,.45a1.73,1.73,0,1,0,.5,3.42h0l3-.43h0a1.73,1.73,0,1,0-.5-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M292.91,161.52l-3,.57a1.72,1.72,0,0,0,.64,3.39h0l3-.55h0a1.72,1.72,0,1,0-.63-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M282.9,163.56l-3,.71a1.72,1.72,0,1,0,.79,3.34h0l2.94-.69h0a1.72,1.72,0,0,0-.78-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M273,166.06l-3,.84a1.71,1.71,0,0,0,.94,3.29h0l2.91-.82h0a1.71,1.71,0,0,0-.93-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M263.2,169l-2.91,1a1.69,1.69,0,0,0,1.1,3.2h0l2.85-1h0a1.7,1.7,0,1,0-1.08-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M253.58,172.53l-2.85,1.15a1.67,1.67,0,1,0,1.25,3.09h0l2.8-1.11,0,0a1.67,1.67,0,0,0-1.24-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M244.16,176.55l-2.77,1.32a1.64,1.64,0,0,0,1.41,3h0l2.73-1.28h0a1.65,1.65,0,1,0-1.4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M235,181.15l-2.69,1.49a1.62,1.62,0,0,0,1.58,2.84h0l2.64-1.45,0,0a1.63,1.63,0,0,0-1.58-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M226.17,186.35,223.59,188a1.6,1.6,0,1,0,1.75,2.68h0l2.53-1.64,0,0a1.61,1.61,0,1,0-1.74-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M217.72,192.18l-2.44,1.87a1.58,1.58,0,0,0,1.92,2.51l0,0,2.4-1.82,0,0a1.59,1.59,0,0,0-1.92-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M209.75,198.65l-2.28,2.07a1.55,1.55,0,0,0-.11,2.2,1.57,1.57,0,0,0,2.2.11l0,0,2.24-2,0,0a1.56,1.56,0,1,0-2.09-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M202.35,205.77l-2.1,2.26a1.54,1.54,0,1,0,2.25,2.09l0,0,2-2.19,0,0a1.54,1.54,0,0,0-2.25-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M195.59,213.52,193.71,216a1.51,1.51,0,1,0,2.4,1.84l0,0,1.84-2.37,0,0a1.52,1.52,0,0,0-.27-2.13,1.5,1.5,0,0,0-2.13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M189.62,221.91,188,224.53a1.49,1.49,0,0,0,2.53,1.57l0,0,1.59-2.54,0,0a1.5,1.5,0,0,0-2.54-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M184.52,230.84l-1.36,2.77a1.46,1.46,0,0,0,2.63,1.29l0,0,1.33-2.69,0,0a1.47,1.47,0,1,0-2.64-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M180.3,240.21l-1.09,2.88a1.46,1.46,0,0,0,.84,1.87,1.45,1.45,0,0,0,1.86-.84l0,0,1.07-2.8,0,0a1.45,1.45,0,0,0-2.71-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M177,249.93l-.82,3a1.42,1.42,0,1,0,2.73.76v0l.82-2.88v0a1.43,1.43,0,0,0-2.75-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M174.54,259.9l-.56,3a1.4,1.4,0,1,0,2.75.51v0l.56-2.95v0a1.4,1.4,0,1,0-2.76-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M173,270l-.3,3.06a1.38,1.38,0,0,0,2.75.27v0l.3-3v0A1.38,1.38,0,0,0,173,270Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M172.28,280.27l0,3.08a1.36,1.36,0,1,0,2.71,0v0l.05-3v0a1.36,1.36,0,0,0-2.72-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M172.44,290.52l.22,3.07a1.33,1.33,0,1,0,2.66-.19v0l-.2-3v0a1.33,1.33,0,0,0-1.42-1.25,1.34,1.34,0,0,0-1.25,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M173.47,300.72l.47,3a1.31,1.31,0,1,0,2.59-.4v0l-.45-3v0a1.32,1.32,0,0,0-2.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M175.35,310.8l.73,3a1.29,1.29,0,0,0,2.5-.61v0l-.7-2.93v0a1.29,1.29,0,0,0-2.51.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M178.09,320.68l1,2.92a1.26,1.26,0,1,0,2.39-.82v0l-1-2.85v0a1.27,1.27,0,1,0-2.41.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M181.69,330.28l1.25,2.81a1.24,1.24,0,0,0,2.27-1v0L184,329.3v0a1.25,1.25,0,0,0-2.29,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M186.15,339.51l1.51,2.68a1.22,1.22,0,1,0,2.13-1.19l0,0-1.46-2.63v0a1.23,1.23,0,0,0-1.67-.47,1.21,1.21,0,0,0-.48,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M191.48,348.27l1.77,2.52a1.18,1.18,0,1,0,1.94-1.34l0,0-1.71-2.48,0,0a1.19,1.19,0,0,0-2,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M197.65,356.47l2,2.33a1.15,1.15,0,0,0,1.74-1.49l0,0-1.94-2.3,0,0a1.15,1.15,0,1,0-1.76,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M204.62,364l2.24,2.11a1.1,1.1,0,0,0,1.56,0,1.09,1.09,0,0,0,0-1.55l0,0-2.18-2.08,0,0a1.12,1.12,0,0,0-1.58,0,1.11,1.11,0,0,0,0,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M212.32,370.76l2.44,1.87a1.06,1.06,0,1,0,1.3-1.67l0,0-2.37-1.86,0,0a1.08,1.08,0,0,0-1.51.19,1.07,1.07,0,0,0,.19,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M220.65,376.73l2.6,1.63a1,1,0,0,0,1.41-.32,1,1,0,0,0-.32-1.41h0L221.78,375l0,0a1,1,0,0,0-1.11,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M229.49,381.88l2.74,1.38a1,1,0,1,0,.89-1.75h0l-2.68-1.38h0a1,1,0,1,0-.91,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M238.77,386.19l2.85,1.13a.94.94,0,0,0,.7-1.75h0l-2.79-1.13h0a1,1,0,1,0-.72,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M248.38,389.66l2.94.88a.9.9,0,0,0,.52-1.73h0l-2.89-.89h0a.92.92,0,1,0-.54,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M258.25,392.29l3,.63a.87.87,0,0,0,1-.67.86.86,0,0,0-.66-1h0l-2.95-.63h0a.87.87,0,0,0-.37,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M268.31,394.08l3,.37a.83.83,0,0,0,.2-1.64h0l-3-.39h0a.84.84,0,1,0-.22,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M278.47,395l3.06.12a.79.79,0,0,0,.07-1.57h0l-3-.14h0a.8.8,0,0,0-.07,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M288.68,395.09l3.06-.14a.75.75,0,1,0-.07-1.49h0l-3,.12h0a.76.76,0,0,0,.06,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M298.85,394.3l3-.4a.71.71,0,0,0-.18-1.4h0l-3,.38h0a.7.7,0,0,0-.62.79.73.73,0,0,0,.8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M308.93,392.64l3-.68a.66.66,0,0,0-.28-1.29h0l-3,.64h0a.67.67,0,1,0,.28,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M318.8,390.08l2.91-.94a.62.62,0,0,0-.38-1.19h0l-2.88.9h0a.64.64,0,0,0,.39,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M328.39,386.62l2.81-1.21a.58.58,0,0,0,.3-.77.57.57,0,0,0-.76-.3h0l-2.79,1.18h0a.59.59,0,0,0-.31.78.6.6,0,0,0,.78.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M337.61,382.26l2.67-1.48a.54.54,0,1,0-.52-.95h0l-2.66,1.45h0a.55.55,0,0,0-.22.75.56.56,0,0,0,.75.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M346.34,377l2-1.36a.51.51,0,0,0-.57-.84h0l-2,1.33h0a.51.51,0,0,0-.14.71.52.52,0,0,0,.72.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156.35,240.52a2,2,0,0,1-1.63-.82l-3.54-4.81a30.85,30.85,0,0,1-8.4-.76l-4.35,4.1a2,2,0,0,1-2.32.32l-7.2-3.77a2,2,0,0,1-1.06-2.09l.89-5.92a31,31,0,0,1-5.4-6.46l-6-.18a2,2,0,0,1-1.87-1.41L113.07,211a2,2,0,0,1,.73-2.23l4.81-3.55a31.18,31.18,0,0,1,.76-8.39l-4.1-4.35a2,2,0,0,1-.32-2.33l3.77-7.2a2,2,0,0,1,2.1-1.06l5.91.9a30.65,30.65,0,0,1,6.46-5.4l.18-6a2,2,0,0,1,1.41-1.87l7.76-2.42a2,2,0,0,1,2.23.72l3.55,4.82a30.78,30.78,0,0,1,8.39.76l4.35-4.11a2,2,0,0,1,2.32-.32l7.21,3.77a2,2,0,0,1,1.06,2.1l-.9,5.91a31,31,0,0,1,5.41,6.47l6,.17a2,2,0,0,1,1.87,1.42l2.43,7.76a2,2,0,0,1-.73,2.23l-4.82,3.54a30.85,30.85,0,0,1-.76,8.4l4.11,4.35a2,2,0,0,1,.32,2.32l-3.77,7.2a2,2,0,0,1-2.09,1.06l-5.92-.89a30.76,30.76,0,0,1-6.47,5.4l-.17,6a2,2,0,0,1-1.41,1.86L157,240.43A2.08,2.08,0,0,1,156.35,240.52Zm-.27-2.89h0Zm-3.5-5.77,4.12,5.58,6.52-2,.2-6.93.7-.41a28.08,28.08,0,0,0,7-5.83l.52-.61,6.86,1,3.18-6-4.77-5.05.21-.78a28,28,0,0,0,.81-9.06l0-.8,5.58-4.12-2-6.52-6.93-.2-.41-.7a27.85,27.85,0,0,0-5.83-7l-.61-.53,1-6.86-6.06-3.17-5,4.76-.78-.21a27.89,27.89,0,0,0-9.05-.81l-.81,0-4.11-5.58-6.52,2-.21,6.93-.69.41a27.9,27.9,0,0,0-7,5.83l-.53.61-6.86-1-3.17,6.06,4.76,5-.2.78a28.18,28.18,0,0,0-.82,9.05l.06.81-5.58,4.11,2,6.53,6.93.2.41.69a27.9,27.9,0,0,0,5.83,7l.61.53-1,6.86,6.06,3.17,5-4.76.78.2a28,28,0,0,0,9.06.82ZM137.47,236Zm-7.21-3.77h0Zm51.84-15.11Zm-.89-27.42Zm-60.84-4.91h0Zm48.86-9.43Zm-32.94-3.87h0Zm-1.46,0h0Zm8.59-1.54ZM149.69,225a21.08,21.08,0,0,1-6.3-41.2,21.58,21.58,0,0,1,4.4-.88,1.47,1.47,0,0,1,1.59,1.33,1.46,1.46,0,0,1-1.32,1.59,18.16,18.16,0,1,0,13.71,4.54,1.47,1.47,0,0,1,1.95-2.19,21.08,21.08,0,0,1-14,36.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M903.43,399.73s-11.26,10.67-15,29.65-12.56-26.83-12.56-26.83H867s-3.37,47.2,21.85,51a13.55,13.55,0,0,0,12.63-5c4.61-5.84,11.79-16.25,13.52-26.16C913.48,406.71,903.43,399.73,903.43,399.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M960.63,615.52a1.37,1.37,0,0,0,0-.34c-2.11-6.6-10.75-10-10.75-10l-4.15.26c-2.39,5.81-3.93,8.65-3.55,10.24,0,0,0,.09,0,.13A125.64,125.64,0,0,0,960.63,615.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M942.18,619.09a1.69,1.69,0,0,0,1.32,1c4.88.8,12.62.16,15.88-.18a1.3,1.3,0,0,0,1.25-1.18A126,126,0,0,1,942.18,619.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M953.26,598.74l-1.82,8.75a1.44,1.44,0,0,1-1.22,1.18,11.78,11.78,0,0,1-2.82,0,1.8,1.8,0,0,1-1.43-2.11l1.27-7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M906.89,618.62c4.43-.13,6.73-.65,7.92-1.13,0,.44,0,.89,0,1.35a.86.86,0,0,1-.83.89l-24.36-.15a1.11,1.11,0,0,1-.9-1.62C891.89,618.22,900,618.81,906.89,618.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M888.7,618a1.14,1.14,0,0,1,.1-.19c2.15-3,7.63-9,18.45-11.59l5.2-.16s2.31,4,2.36,11.47c-1.19.48-3.49,1-7.92,1.13C900,618.81,891.89,618.22,888.7,618Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M913.41,598.15c-.06.39-.77,6.27-1,8.55a1.14,1.14,0,0,1-1,1,11.9,11.9,0,0,1-3.56-.05,1.54,1.54,0,0,1-1.17-1.54v-9.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M949.79,483.76s8.31,73.88,3.69,120.06c0,0-5.54,0-8.31-.93,0,0-8.63-72.23-11.43-92.9a.69.69,0,0,0-1.37-.05c-3.45,17.39-17,85.59-18.6,92,0,0-4.61,1.85-8.31,0,0,0,7.39-98.81,12.93-116.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M966.41,397.88s-35.09-5.54-62.79,1.85l1.84,28.62s7.39,39.71,12.93,57.26c0,0,21.24,3.69,31.4-1.85,0,0,8.31-49.87,12.93-57.25C962.72,426.51,967.34,407.11,966.41,397.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M941.79,367.74l3.74,28.55s-9.77,4.48-16.61-.2l1.48-16.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M966.41,397.88s54.49,59.1-9.69,81.73V475s24-20.32,5.54-48C962.26,427,964.56,400.65,966.41,397.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M956.25,475.45s-8.31-5.54-12-3.69-3.7,4.62-3.7,4.62,1.85,3.69,4.62,2.77,9.24.92,12,0C957.18,479.15,958.1,475.45,956.25,475.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M866.25,372.88l11.48,3.81a3.75,3.75,0,0,1,2.43,3.61l-.72,19.29c.16,3-2.33,5.69-4.67,5l-9.2-3.09a2.35,2.35,0,0,1-1.48-2.38l0-24C864,373.73,865.19,372.56,866.25,372.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M864.17,397.88s-3.67-11.76-1.8-13.74,5.58-7.44,5.83-3S870.69,404.92,864.17,397.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M921.69,361.83c-.1.33,1.14,23,1.14,23l12.94-1,2-21.67S923.33,356.32,921.69,361.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M934.68,366.7a1.78,1.78,0,0,1,.72,1.42l0,10.75a2,2,0,0,1-.08.48c-.26.85-1.33,3.51-4.21,2.25-2.45-1.07-4.72-2-6.49-2a1.75,1.75,0,0,0-1.73,1.86,63.59,63.59,0,0,0,1.42,9.68,1.88,1.88,0,0,0,2.08,1.37A52.26,52.26,0,0,0,937.62,390a1.71,1.71,0,0,0,1.12-1.44c.28-2.85,1.1-10.85,1.7-13.06.56-2.06,3.38-2.94,4.71-3.24a1.79,1.79,0,0,0,1.18-.85c.74-1.3,1.72-4.07-1.87-5.89a1.76,1.76,0,0,1-.8-2.36c.79-1.52,1.24-3.82-1.63-5.58a6,6,0,0,0-7,.39,2,2,0,0,1-2.32,0,1.29,1.29,0,0,0-1.21-.18,1.87,1.87,0,0,1-2.34-1.07,4.88,4.88,0,0,0-5.07-3.28c-5.74,0-7.21,5.84-6.23,9.52s7.19,3.28,10.46,2C930.76,364.06,933.43,365.74,934.68,366.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M938.56,378.15s-.79-6.33,1.81-7.57,6,.11,4.53,4.68C943.08,380.93,938.56,378.15,938.56,378.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M914.32,359.48a.2.2,0,0,1-.18-.12c-2.06-4.42,2.76-7.94,2.81-8a.19.19,0,0,1,.27.05.2.2,0,0,1,0,.27s-4.6,3.38-2.68,7.5a.19.19,0,0,1-.09.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M838.11,373.33V413.7c0,3.29-2,5.95-4.48,5.95h-147c-2.05,0-3.84,1.86-4.34,4.51l-2.64,14.06c-.35,1.86-2.3,2-2.81.22l-3.4-11.87c-.67-2.31-2.33-3.84-4.19-3.84h-6.32c-2.47,0-4.48-2.67-4.48-6v-41.5c0-3.27,2-5.92,4.44-5.95l170.75-1.95C836.08,367.35,838.11,370,838.11,373.33Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 681.16,
    cy: 393.77,
    rx: 18.04,
    ry: 18.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M687.7,386.27c0,3.32-2.7,6.91-6,6.91s-6-3.59-6-6.91a6,6,0,0,1,12.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M674.2,406h14.7a3.56,3.56,0,0,0,3.39-2.47l.79-2.47a3.55,3.55,0,0,0-2.15-4.42c-6-2.19-12.16-1.91-18.5.2a3.54,3.54,0,0,0-2.27,4.29l.61,2.25A3.55,3.55,0,0,0,674.2,406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M824.06,398.6a3.58,3.58,0,0,1-3.65,3.5H713.08a3.57,3.57,0,0,1-3.64-3.5h0a3.57,3.57,0,0,1,3.64-3.5H820.41a3.58,3.58,0,0,1,3.65,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M773.24,409.82a3.18,3.18,0,0,1-3.18,3.18H713.79a3.18,3.18,0,0,1-3.18-3.18h0a3.18,3.18,0,0,1,3.18-3.18h56.27a3.18,3.18,0,0,1,3.18,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M824.12,409.82a3.18,3.18,0,0,1-3.18,3.18H780.33a3.18,3.18,0,0,1-3.18-3.18h0a3.18,3.18,0,0,1,3.18-3.18h40.61a3.18,3.18,0,0,1,3.18,3.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 709.14,
    y: 376.79,
    width: 63.12,
    height: 9.3,
    rx: 4.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M344.43,395.1c0,35.49-.31,157.88-2.43,201.21-.22,4.59-3.45,8.21-7.38,8.27-19.44.31-90.66.62-122.39-1.64-6.61-.47-11.73-6.86-11.7-14.6.17-37.25,1-142,5.55-189.88.55-5.73,4.5-10.23,9.42-10.69,21.2-2,92.83-6.47,120.22-3.78C340.66,384.47,344.43,389.3,344.43,395.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M335.52,405.79c.41,28.65,1.6,124-.22,159.16-.27,5.14-3.83,9.23-8.23,9.43-18.13.84-79.93,2.2-106.41-.87-4.77-.55-8.42-5.16-8.56-10.77-.7-29.23-2.6-118-.82-152.8.28-5.55,4.06-10,8.8-10.4,19.63-1.62,85.34-5.06,107.86-3.12C332.17,396.78,335.45,400.83,335.52,405.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M289.11,389.75h0a1.93,1.93,0,0,1-1.7,2c-4.6.18-17.53.69-23.32.95a2,2,0,0,1-1.76-2.47l0-.22a1.87,1.87,0,0,1,1.6-1.61c3.91-.34,15.71-1.23,23.51-.74A1.94,1.94,0,0,1,289.11,389.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-166",
    cx: 273.42,
    cy: 485.69,
    r: 45.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M301.42,497.59a8.11,8.11,0,0,0-4.82-5.34l-3.27-1.3A6.28,6.28,0,0,0,286,493l-2.92,3.9a23.87,23.87,0,0,1-14.56-5.09,24.25,24.25,0,0,1-8.75-11.72.13.13,0,0,1,.06-.16.14.14,0,0,1,.16,0l2.63-3.51a7.17,7.17,0,0,0-.13-8.77L260.31,465a8.21,8.21,0,0,0-13,.19,10.76,10.76,0,0,0-1.73,3.53c-2.41,8.53,4.46,21.43,17.14,30.92s27,12.44,34.48,7.73a10.86,10.86,0,0,0,2.91-2.66A8.12,8.12,0,0,0,301.42,497.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M219.23,596.64a14,14,0,0,1-14-13.9V559a.49.49,0,1,1,1,0v23.76a13,13,0,0,0,13,12.89.51.51,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M142.74,600.55s-.94,5.33-1.41,10.61a3.64,3.64,0,0,0,3.48,3.94c7,.29,22.07.86,27.46.62a1.18,1.18,0,0,0,1-1.62h0a2.7,2.7,0,0,0-1.35-1.43l-24.84-11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M142,597.42l.75,6.37s4.35,2,7.32-.25l-1.8-7.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M142.53,477.52c-.32,1.66-1.75,83.11,7,119.6a1.25,1.25,0,0,1-.73,1.45,21.86,21.86,0,0,1-7.09,1.44,2.15,2.15,0,0,1-2.12-1.53c-2.49-8.47-14.41-50.9-16-91.43-1.73-45.29,0-1.54,0-1.54l1-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M114.17,603.33s-1.5,2.69-3,9.84a2.22,2.22,0,0,0,2,2.66c2.32.23,5.9.52,8.76.5a2.2,2.2,0,0,0,2.19-2.46,18.69,18.69,0,0,0-4.36-10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M112.85,595.13l1.77,9.64s1.75,1.3,5.21.36L119,594.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M108.08,480c-7.12,43,1.54,106.2,4.46,118.58a1.91,1.91,0,0,0,1.56,1.46,12.82,12.82,0,0,0,5.57-.22,1.77,1.77,0,0,0,1.27-1.63c.4-10-.31-71.43,6.32-95.71a5.54,5.54,0,0,1,2.13-3l12.88-9.15,1-14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M153.45,398.6c-21.34-.36-44.88,5.6-44.88,5.6-6.36,37.11-1.12,79.92-1.12,79.92,16.52,4.33,35.16-2.65,35.16-2.65,2.74-15.51,15.55-59.17,15.55-59.17A70.13,70.13,0,0,0,184.25,414c-5.4-6.25-7.94-14.21-9-18.91A71.74,71.74,0,0,1,153.45,398.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M216.47,367.17a4.09,4.09,0,0,0-4.75-1.34c-3.13,13.27-19.6,24-36.51,29.28,1.1,4.7,3.64,12.66,9,18.91C212.32,398.24,216.47,367.17,216.47,367.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M216,367.81c.21.7-2.33,1.76-3.82-1.09-.05-1.37-.88-7.22-.07-8.34,4.35-5.93,12.78-13.36,12.78-13.36a2,2,0,0,1,.26,2.79L221,352.07a20.09,20.09,0,0,1,2.38,4.72,5.71,5.71,0,0,1-.57,4.22c-.72,1.29-1.7,3-2.62,4.29A5.66,5.66,0,0,1,216,367.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M219.24,354.83,215.51,358l-1.17,3.15,3.32,3.69s1.12-6.24,2-7.6S220,355.23,219.24,354.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M116.75,424.86l-8.18-20.66s-19.94,13.54-23.21,30.71a45.31,45.31,0,0,1,16.78,4.71C105.17,432.81,116.75,424.86,116.75,424.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M131.83,381.27,125,400.91a.72.72,0,0,0,.33.85c1.85,1,8.51,4,16.55-1.11a3.3,3.3,0,0,0,1.53-2.38l2.2-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M146.61,363.09s7.45,14,6.5,19.71-10.2,5.26-18.27.65L129.2,368.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M135.2,376a.58.58,0,0,0,.25-.85,14.79,14.79,0,0,1-2.07-4.4s-1.34-.86,3.41-2,11.83-2.91,13.32-6.95-2.36-13.86-8.45-6a.57.57,0,0,1-.91,0c-1-1.3-3.62-4-7.27-2.36-3.4,1.53-3.79,4-3.74,5.28a.58.58,0,0,1-.68.59c-1.73-.33-5.86-.61-7.79,3.63-1.59,3.5-.56,5.47.38,6.44a.58.58,0,0,1-.24,1c-1.14.35-2.6,1.31-2.45,4,.2,3.67,4.3,3.34,5.47,3.18a.57.57,0,0,1,.51.18c1,1.11,5.52,5.81,10.4,6.38a.58.58,0,0,0,.61-.77l-2.11-6.14a.57.57,0,0,1,.31-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M136.05,376.88s-5.31-3.64-5.7-.57,4.78,4.44,7.34,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M85.5,435.08s-13.63,31,19.67,35.57l4.54-3.79s-16.65-9.08-7.57-27.24C102.14,439.62,92.31,431.29,85.5,435.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M109.41,451.41l11.72,3.95a3.9,3.9,0,0,1,2.52,3.68L123,478.61c.19,3.06-2.34,5.76-4.73,5l-9.4-3.2a2.42,2.42,0,0,1-1.53-2.42l-.21-24.36C107.16,452.26,108.33,451.09,109.41,451.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M106.38,474.61a15.91,15.91,0,0,1-1.95-9.73c.57-5.36-.48-7.78,2-7.58s4.57.63,4.29,3.27S111.24,480,106.38,474.61Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact_img.098e0e07296b7afdbfccae324b363c40.svg";
export { ForwardRef as ReactComponent };